<template>
    <collapsible-card :title="'Platform Information'" class="infoWidth" v-show="showInfo" ref="cCard">
        <div class="cardContent">
            <div class="info2Cols">
                <div v-if="general.length > 0 || type" class="category">
                    <h3 class="categoryTitle">General</h3>
                    <div v-if="type">
                        <p>Type: <span class="dataEmphasis">{{type}}</span></p> 
                    </div>
                    <div v-if="operator">
                        <p>Operator: <router-link :to="{name: 'Operators', params: {operator: operator_short}}" class="link dataEmphasis">{{operator}}</router-link></p> 
                    </div>
                    <div v-for="obj in general" :key="obj.field" class="dataItem">
                        <p v-if="obj.field === 'MMSI'">{{obj.field}}: <router-link :to="{name: 'Vessels', params: {mmsi: obj.val}}" class="link dataEmphasis">{{obj.val}}</router-link></p>
                        <p v-else-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
                 <div v-if="dates.length > 0" class="category">
                    <h3 class="categoryTitle">Dates</h3>
                    <div v-for="obj in dates" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import { readFromObj } from '../../helpers/Formatting.js';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: 'platform-info',
    components: {
        CollapsibleCard
    },
    data: () => ({
        showInfo: false,
        operator: "",
        operator_short: "",
        type: "",
        general: [],
        dates: []
    }),
    methods: {
        updateInfo: function(platformInfo) {
            let globv = this;

            if (platformInfo['operator'])
                globv.operator = platformInfo['operator'];

            if (platformInfo['oper_short'])
                globv.operator_short = platformInfo['oper_short'];

            if (platformInfo['type'])
                globv.type = platformInfo['type'];

            let expectedVariables = [
                {
                    varName: "name",
                    fieldName: "Platform"
                }
            ]

            globv.general = readFromObj(platformInfo, expectedVariables);

            globv.general.push({
                field: "Latitude / Longitude",
                val: platformInfo['lat'] + "° / " + platformInfo['lon'] + "°"
            });

            expectedVariables = [
                {
                    varName: "install_date",
                    fieldName: "Install Date",
                },
                {
                    varName: "revised_date",
                    fieldName: "Revised Date",
                }
            ]

            globv.dates = readFromObj(platformInfo, expectedVariables);

            globv.showInfo = globv.general.length > 0 || globv.company || globv.type || globv.dates.length > 0;
            globv.$refs.cCard.adjustHeight();
        }
    }
}
</script>

<style lang="scss">
.infoWidth {
    max-width: 750px;
}

.infoVerticalSpacing {
    margin-top: 10%;
}
</style>